import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addDomainTransferToCart } from "features/common/layouts/cartSlice";
import { addEpp } from "features/domain/domainsSlice";
import Spinner from "react-bootstrap/Spinner";
import {
  formatIDR,
  // useQuery 
} from "helpers/utils";
// import { useLocation } from "react-router-dom";
// import custom from "../../assets/scss/SuccessDomain.module.scss"; // File sudah dihapus
import { notifyError, notifyWarning, notifySuccess, notifyInfo } from "components/ToastMessage";
import { hasFreeDomainInCart, getIsFreeDomain as getIsFreeDomainHelper } from "../../helpers/helpersSuccessDomain";
// import { getOnlyTLD } from "helpers/helper";
const SuccessDomainTransfer = (props) => {
  const { onToggleDomainSections } = props;
  const dispatch = useDispatch();
  // const location = useLocation();
  // const query = useQuery();
  const results = useSelector((state) => state.domain.domain_transfer);
  const { status } = useSelector((state) => state.domain);
  const cartItems = useSelector((state) => state.cart.productsList);
  // const { freeDomainExtensions } = useSelector((state) => state.hosting);
  const [epp, setEpp] = useState("");
  const [premiumDomainData, setPremiumDomainData] = useState({}); // Store premium domain data: { domain: { is_premium, public_price, registrar_price } }
  // const [kemerdekaanPromo, setKemerdekaanPromo] = useState(false);

  // const { domain, duration } = results[0] ?? { domain: "", duration: 0 };

  // Gunakan helper function untuk menentukan apakah domain gratis
  const getIsFreeDomain = (domain, duration, cartItems, isTransfer = false) => {
    return getIsFreeDomainHelper(domain, duration, cartItems, isTransfer);
  };

  // Check if any domain can be transferred (status "not-available" and not in pending states)
  const hasTransferableDomain = results.some(result => 
    result.status === "not-available" && 
    !result.whois.includes("pendingDelete") && 
    !result.whois.includes("redemptionPeriod")
  );

  // Handle "Isi Domain Nanti" button click
  const handleIsiDomainNanti = () => {
    if (onToggleDomainSections && typeof onToggleDomainSections === 'function') {
      // Hide the domain sections permanently
      onToggleDomainSections(false);
    } else {
      // Jika onToggleDomainSections tidak ada, hanya tampilkan notifikasi
      notifyInfo("Anda dapat menambahkan domain nanti di halaman checkout.");
    }
  };

  const addDomainToCartHandler = (e) => {
    const availableDomains = results.filter(
      (result) => result.status === "not-available"
    );
    availableDomains.forEach((result, i) => {
      if (!epp) {
        notifyError(`Masukkan Kode EPP Domain Anda!`);
        return;
      } else {
        const { domain, status, price, duration } = result;
        if (cartItems.find((list) => list.domain === domain)) {
          notifyWarning("Domain Anda sudah berada didalam keranjang.");
          return;
        }

        const premiumData = premiumDomainData[domain];
        const isPremiumDomain = premiumData && premiumData.is_premium && domain.endsWith(".id");
        
        // Use premium price if domain is premium, otherwise use regular price
        let basePrice = isPremiumDomain ? premiumData.public_price : price;
        
        const isDomainFree = getIsFreeDomain(domain, duration, cartItems, true);
        const hasExistingFreeDomain = hasFreeDomainInCart(cartItems);
        
        // Apply free domain logic (only if not premium domain)
        let finalPrice = basePrice;
        if (isDomainFree && !hasExistingFreeDomain && !isPremiumDomain) {
          finalPrice = 0;
        }
        
        // Premium domains are always 1 year for transfer
        const finalDuration = isPremiumDomain ? 1 : duration;

        dispatch(addEpp({ epp, domain: domain }));
        dispatch(
          addDomainTransferToCart({
            name: domain,
            price: finalPrice,
            status,
            domain: domain,
            type: "transfer",
            eppCode: epp,
            duration: finalDuration,
            isFreeDomain: isDomainFree && !isPremiumDomain
          })
        );
        notifySuccess("Domain berhasil ditambahkan ke keranjang.");
      }
    });
  };

  // Fetch premium domain data
  const fetchPremiumDomainData = async (domain) => {
    try {
      // Only check for .id domains
      if (!domain.endsWith('.id')) {
        return;
      }

      const response = await fetch(
        `${process.env.REACT_APP_BASE_API}order/apis/checkDomainPremium.php?domain=${encodeURIComponent(domain)}`
      );
      const data = await response.json();

      if (data.code === 200 && data.is_premium && data.data) {
        setPremiumDomainData((prev) => ({
          ...prev,
          [domain]: {
            is_premium: true,
            public_price: data.data.public_price,
            registrar_price: data.data.registrar_price,
            character_count: data.data.character_count
          }
        }));
      } else {
        // Domain bukan premium, set false
        setPremiumDomainData((prev) => ({
          ...prev,
          [domain]: {
            is_premium: false,
            public_price: null,
            registrar_price: null,
            character_count: null
          }
        }));
      }
    } catch (error) {
      console.error("Error fetching premium domain data:", error);
      // Set false on error
      setPremiumDomainData((prev) => ({
        ...prev,
        [domain]: {
          is_premium: false,
          public_price: null,
          registrar_price: null,
          character_count: null
        }
      }));
    }
  };

  // Fetch premium domain data when results change (only for .id domains)
  useEffect(() => {
    if (results && results.length > 0) {
      results.forEach((result) => {
        if (result.status === "not-available" && result.domain.endsWith(".id")) {
          // Only fetch if not already fetched or if data is not premium
          const existingData = premiumDomainData[result.domain];
          if (!existingData || existingData.is_premium === undefined) {
            fetchPremiumDomainData(result.domain);
          }
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [results]);

  // Check Kemerdekaan promo period (17-18 Agustus 2025) - DISABLED for transfer
  // useEffect(() => {
  //   // Promo Kemerdekaan tidak berlaku untuk domain transfer
  //   setKemerdekaanPromo(false);
  // }, [results]);

  // Auto-open domain sections when transferable domains are found - DISABLED
  // useEffect(() => {
  //   if (hasTransferableDomain && onToggleDomainSections) {
  //     onToggleDomainSections(true); // Open domain sections
  //   }
  // }, [hasTransferableDomain, onToggleDomainSections]);

  return (
    <>
      {status === "loading" && (
        <div className="text-center my-5">
          <Spinner animation="border" />
        </div>
      )}
      {status === "error" && (
        <div>An error occurred. Please try again later.</div>
      )}
      {status === "fulfilled" && (
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-12">
              {results.map((result, i) => (
                <div key={i} className="mb-4">
                  {/* Case 1: Domain bisa ditransfer */}
                  {result.status === "not-available" &&
                    (!result.whois.includes("pendingDelete") &&
                      !result.whois.includes("redemptionPeriod")) && (
                      <div className="py-3">
                        <div className="row align-items-center mb-4">
                          <div className="col-12 col-lg-6 mb-3 mb-lg-0 d-flex align-items-center flex-wrap gap-2">
                            <p className="mb-0 fw-bold" style={{ fontSize: "clamp(16px, 2vw, 20px)", color: "#ee4d30" }}>
                              {result.domain}
                            </p>
                            {(() => {
                              const premiumData = premiumDomainData[result.domain];
                              const isDomainPremium = premiumData && premiumData.is_premium && result.domain.endsWith(".id");
                              
                              if (isDomainPremium) {
                                return (
                                  <span
                                    className="badge"
                                    style={{ 
                                      fontSize: "clamp(10px, 1.2vw, 12px)", 
                                      fontWeight: "700",
                                      backgroundColor: "#ee4d30",
                                      color: "#fff",
                                      padding: "4px 8px",
                                      borderRadius: "4px"
                                    }}
                                  >
                                    Domain Premium
                                  </span>
                                );
                              }
                              return null;
                            })()}
                          </div>
                          <div className="col-12 col-lg-6 text-end text-lg-end d-flex justify-content-end justify-content-lg-end">
                            {(() => {
                              const premiumData = premiumDomainData[result.domain];
                              const isPremiumDomain = premiumData && premiumData.is_premium && result.domain.endsWith(".id");
                              
                              // Use premium price if domain is premium
                              const displayPrice = isPremiumDomain ? premiumData.public_price : result.price;
                              
                              const isDomainFree = getIsFreeDomain(result.domain, result.duration, cartItems, true);
                              const hasExistingFreeDomain = hasFreeDomainInCart(cartItems);
                              
                              // Apply free domain logic (only if not premium domain)
                              if (isDomainFree && !hasExistingFreeDomain && !isPremiumDomain) {
                                return (
                                  <div className="d-flex flex-column align-items-end">
                                    <span className="text-muted small fw-bold text-decoration-line-through">
                                      {formatIDR(displayPrice)}
                                    </span>
                                    <div className="d-flex flex-column align-items-end">
                                      <span className="fw-bold">{formatIDR(0)}</span>
                                      <span className="badge bg-success text-white p-2 mt-1">
                                        GRATIS DOMAIN!
                                      </span>
                                    </div>
                                  </div>
                                );
                              } else {
                                return (
                                  <p className="mb-0 fw-bold text-end" style={{ fontSize: "18px", color: isPremiumDomain ? "#ee4d30" : "inherit" }}>
                                    {formatIDR(displayPrice)}
                                  </p>
                                );
                              }
                            })()}
                          </div>
                        </div>

                        {/* EPP Code Input */}
                        <div className="mb-4">
                          <label htmlFor={`epp-code-${i}`} className="form-label fw-bold mb-2" style={{ fontSize: "15px", color: "#333" }}>
                            EPP Code
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id={`epp-code-${i}`}
                            placeholder="Masukkan Kode EPP"
                            onChange={(e) => setEpp(e.target.value)}
                            style={{ fontSize: "15px", padding: "10px 15px" }}
                          />
                          <div className="form-text mt-2" style={{ fontSize: "13px", color: "#6c757d" }}>
                            Informasi Kode EPP Dapat Dilihat Pada Registrar Domain Anda Sebelumnya.
                          </div>
                        </div>

                        {/* Tombol */}
                        <div className="d-flex justify-content-center mt-4">
                          <button
                            className="btn btn-cta px-5 py-2 rounded-5 fw-bold"
                            style={{ fontSize: "15px", minWidth: "200px" }}
                            onClick={hasTransferableDomain ? addDomainToCartHandler : handleIsiDomainNanti}
                          >
                            {hasTransferableDomain ? "Tambahkan ke Keranjang" : "Isi Domain Nanti"}
                          </button>
                        </div>
                      </div>
                    )}

                  {/* Case 2: Domain dalam status pending/redemption */}
                  {(result.whois.includes("pendingDelete") ||
                    result.whois.includes("redemptionPeriod")) && (
                      <div className="py-3">
                        <div className="alert alert-danger d-flex align-items-center mb-0" style={{ borderRadius: "8px", padding: "12px 16px" }}>
                          <i className="fas fa-exclamation-triangle me-2"></i>
                          <small className="mb-0" style={{ fontSize: "14px" }}>
                            <strong>{result.domain}</strong> berstatus pending delete atau redemption
                          </small>
                        </div>
                      </div>
                    )}

                  {/* Case 3: Domain error transfer */}
                  {result.status === "error" && (
                    <div className="py-3">
                      <div className="alert alert-danger d-flex align-items-center mb-0" style={{ borderRadius: "8px", padding: "12px 16px" }}>
                        <i className="fas fa-times-circle me-2"></i>
                        <small className="mb-0" style={{ fontSize: "14px" }}>
                          <strong>{result.domain}</strong> tidak dapat ditransfer. Silakan cek status domain Anda.
                        </small>
                      </div>
                    </div>
                  )}

                  {/* Case 4: Domain available */}
                  {result.status === "available" && (
                    <div className="py-3">
                      <div className="alert alert-info d-flex align-items-center mb-0" style={{ borderRadius: "8px", padding: "12px 16px" }}>
                        <i className="fas fa-info-circle me-2"></i>
                        <small className="mb-0" style={{ fontSize: "14px" }}>
                          <strong>{result.domain}</strong> tidak dapat ditransfer karena domain belum terdaftar
                        </small>
                      </div>
                    </div>
                  )}

                  {/* Case 5: Domain dengan status null atau tidak ada informasi */}
                  {(result.status === null || result.status === undefined || result.status === "") && (
                    <div className="py-3">
                      <div className="alert alert-warning d-flex align-items-center mb-0" style={{ borderRadius: "8px", padding: "12px 16px" }}>
                        <i className="fas fa-exclamation-circle me-2"></i>
                        <small className="mb-0" style={{ fontSize: "14px" }}>
                          <strong>{result.domain}</strong> - Informasi domain tidak lengkap. Silakan coba lagi atau hubungi support.
                        </small>
                      </div>
                    </div>
                  )}

                  {/* Separator jika ada multiple domains */}
                  {results.length > 1 && i < results.length - 1 && (
                    <hr className="my-4" style={{ borderColor: "#e0e0e0" }} />
                  )}
                </div>
              ))}
              
              {/* Fallback button when no transferable domains are found - DISABLED */}
              {/* {results.length > 0 && !hasTransferableDomain && (
                <div className="text-center my-4">
                  <button
                    className="btn btn-cta px-4 rounded-5"
                    onClick={handleIsiDomainNanti}
                  >
                    Isi Domain Nanti
                  </button>
                </div>
              )} */}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SuccessDomainTransfer;
